import ruleApi from 'api/ruleApi'

import { RuleListRequest, RuleListResponse, RuleSaveRequest } from './types'

const RuleApiSlice = ruleApi.injectEndpoints({
  endpoints: (build) => ({
    getRule: build.query<RuleListResponse, RuleListRequest>({
      query: ({ page }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0
        }

        return {
          url: `/document-ai/v1/field-mappings`,
          method: 'GET',
          params
        }
      },
      providesTags: ['ruleApi']
    }),
    createRule: build.mutation<RuleSaveRequest, RuleListResponse>({
      query: ({ ruleDTO }) => {
        return {
          url: '/document-ai/v1/field-mappings',
          method: 'POST',
          data: ruleDTO,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['ruleApi']
    }),
    updateRule: build.mutation<RuleSaveRequest, RuleListResponse>({
      query: ({ ruleDTO, id }) => {
        return {
          url: `/document-ai/v1/field-mappings/${id}`,
          method: 'PUT',
          data: ruleDTO,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['ruleApi']
    })
  })
})
export const { useGetRuleQuery, useCreateRuleMutation, useUpdateRuleMutation } =
  RuleApiSlice
